import { PayrollValueObjectsConceptUnitTypeEnum } from 'generated/resources/graphql'

import { useCurrencyContext } from 'modules/compensations/lib/CurrencyContext'

type UnitsConfig = Record<PayrollValueObjectsConceptUnitTypeEnum, string>

const DEFAULT_UNITS: UnitsConfig = {
  distance: 'km',
  money: 'EUR', // Default value that will be overridden by the hook. We should use here '€' but Dinero.js uses under
  // the hood CurrencyIsoCode. We plan to remove these Dinero.js uses by our own solution. Take a look currency.ts file.
  time: 'mins',
  unit: 'units',
}

const getUnits = (overrides: Partial<UnitsConfig>) => ({ ...DEFAULT_UNITS, ...overrides })

// This is a workaround until we support dynamic units. We need to provide a way from the server to know the units of a concept.
// Potentially, we could move all this logic to its own context, a kind of "unit context", and return
// a new map with calculated units.
const usePayrollConceptCompensationUnits = (
  unit: PayrollValueObjectsConceptUnitTypeEnum
): string => {
  const [currency] = useCurrencyContext()

  return getUnits({ money: currency.isoCode })[unit]
}

type UsePayrollConceptCompensationUnits = ReturnType<typeof usePayrollConceptCompensationUnits>

const isUnitKey = (unit: string): unit is keyof typeof DEFAULT_UNITS => {
  return unit in DEFAULT_UNITS
}

export { usePayrollConceptCompensationUnits, getUnits, isUnitKey, DEFAULT_UNITS }
export type { UsePayrollConceptCompensationUnits, UnitsConfig }
